import { React, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getAllQuestConfigs } from "../redux/slices/QuestConfigSlice";
import { getAllBlocConfigs } from "../redux/slices/BlocConfigSlice";
import { getSeasonList } from "../redux/slices/SeasonSlice";
import { getAllEnums } from "../redux/slices/EnumsSlice";
import { Spinner } from "reactstrap";
import MyBreadcrumb from "../components/breadcrumb/MyBreadcrumb";
import NewQuestConfigForm from "../components/newQuestConfigPage/NewQuestConfigForm";
import "../components/newQuestConfigPage/newQuestConfigPage.css";
import { Toaster } from "react-hot-toast";

const NewQuestConfigPage = () => {
  const dispatch = useDispatch();

  const { questConfigs, loading_getQuestConfigs } = useSelector((state) => ({ ...state.questConfigs }));
  const { seasonList } = useSelector((state) => ({ ...state.seasonList }));
  const { blocConfigs } = useSelector((stateBloc) => ({ ...stateBloc.blocConfig }));
  const { enumList } = useSelector((state) => ({ ...state.enums }));

  useEffect(() => {
    if (!seasonList) {
      dispatch(getSeasonList());
    }
    if (!blocConfigs) {
      dispatch(getAllBlocConfigs());
    }

    if (!questConfigs) {
      dispatch(getAllQuestConfigs());
    }
    if (!enumList) {
      dispatch(getAllEnums());
    }
  }, []);

  return (
    <div className="new-questConfig-page">
      <MyBreadcrumb pageTitle={"Administration des quêtes"} subPageTitle={"Ajout d'une nouvelle quête"}></MyBreadcrumb>
      {loading_getQuestConfigs ? (
        <div className="get-questConfig-spinner">
          <Spinner color="secondary"></Spinner>
        </div>
      ) : (
        <div className="main-content myCard">
          <NewQuestConfigForm />
        </div>
      )}
      <Toaster></Toaster>
    </div>
  );
};

export default NewQuestConfigPage;
